"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const xstate_1 = require("xstate");
const react_2 = require("@xstate/react");
const prop_types_1 = require("prop-types");
const intl_1 = require("@kyruus/intl");
const RescheduleComponent_1 = __importDefault(require("../RescheduleComponent"));
const styles_1 = require("./styles");
const xstate_2 = require("../../lib/constants/xstate");
const messages_1 = __importDefault(require("../../lib/messages"));
const ConfirmationPage = react_1.default.forwardRef(({ createRescheduleLink, searchProvidersLink, service, track }, ref) => {
    const [currentState] = (0, react_2.useService)(service);
    const canceledPreviously = currentState.matches(xstate_2.states.canceledPreviously);
    const { appointment, locationId, locations, provider, providerId } = currentState.context;
    const headingMessage = canceledPreviously
        ? messages_1.default.previouslyCanceledPageHeading
        : messages_1.default.confirmPageHeading;
    return (react_1.default.createElement("div", { ref: ref },
        react_1.default.createElement(styles_1.HeadingContainer, null,
            canceledPreviously ? (react_1.default.createElement(styles_1.ErrorCircleStyled, { "aria-hidden": "true" })) : (react_1.default.createElement(styles_1.CheckCircleStyled, { "aria-hidden": "true" })),
            react_1.default.createElement(styles_1.ConfirmHeading, null,
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, headingMessage)))),
        react_1.default.createElement(RescheduleComponent_1.default, { appointment: appointment, createRescheduleLink: createRescheduleLink, locationId: locationId, locations: locations, provider: provider, providerId: providerId, searchProvidersLink: searchProvidersLink, service: service, track: track })));
});
ConfirmationPage.displayName = 'ConfirmationPage';
ConfirmationPage.propTypes = {
    /**
     * Callback that takes a providerId, patientRelationship, and patientPurpose and returns a deeplinked directbook URL for rescheduling an appointment
     * @callback createRescheduleLink
     * @param {number} providerId
     * @param {string} patientRelationship
     * @param {string} patientPurpose
     */
    createRescheduleLink: prop_types_1.func.isRequired,
    /**
     * URL link for the `Search Providers` button.
     */
    searchProvidersLink: prop_types_1.string.isRequired,
    /**
     * The interpreted appointment cancel state machine
     */
    service: (0, prop_types_1.instanceOf)(xstate_1.Interpreter).isRequired,
    /**
     * Callback triggered for tracking
     * @callback track
     * @param {string} eventName
     * @param {object} eventData
     */
    track: prop_types_1.func.isRequired
};
exports.default = ConfirmationPage;
//# sourceMappingURL=ConfirmationPage.js.map